import React from 'react';
import { get, first } from 'lodash';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Grid,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  List,
  Drawer,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import { convertImageUrlToPublicId } from '../../lib/cloudinary';
import { isBetaVersion, getMarketName } from '../../lib/utils';

import marketActions from '../../actions/markets';
import MainMenu from '../common/main-menu';
import ProfilePhoto from '../common/profile-photo';

const styles = {
  cleanLink: {
    textDecoration: 'none',
    color: 'white',
  },
};

class MenuAppBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.logout = this.logout.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
  }

  get collapsableDrawer() {
    return (
      <Drawer
        open={this.state.open}
        onClose={() => this.toggleDrawer(false)}
      >
        <div
          tabIndex={0}
          role="button"
          onClick={() => this.toggleDrawer(false)}
          onKeyDown={() => this.toggleDrawer(false)}
        >
          <div style={styles.list}>
            <List>
              <MainMenu />
            </List>
          </div>
        </div>
      </Drawer>
    );
  }

  get primaryMarketNavOption() {
    const markets = get(this, 'props.markets', []);
    const userMarketPreferences = JSON.parse(localStorage.getItem('userMarketPreferences'));
    const marketId = userMarketPreferences.length === 1
      ? first(userMarketPreferences)
      : '';
    const selectedMarket = markets.find((m) => m._id === marketId);

    return (
      <Link
        to={`/operator/markets/${marketId}`}
        style={styles.cleanLink}
        onClick={() => this.props.selectMarket(selectedMarket)}
      >
        My Markets
      </Link>
    );
  }

  get titleOrMarketName() {
    const market = get(this, 'props.selectedMarket');

    if (!market) return 'Wrangler Admin';

    return getMarketName(market);
  }

  logout() {
    this.props.auth.logout();
  }

  toggleDrawer(open) {
    this.setState({
      open,
    });
  }

  render() {
    const { currentWrangler } = this.props;
    const imageUrl = get(currentWrangler, 'profilePhoto.url');
    return (
      <Grid>
        <AppBar position="static" style={isBetaVersion() ? { backgroundColor: 'red' } : {}}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="Menu"
              onClick={() => this.toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <Grid>
              {currentWrangler && currentWrangler.access.can('read', 'MyMarkets') && (
                <Button variant="outlined">
                  {this.primaryMarketNavOption}
                </Button>
              )}
            </Grid>
            <Typography
              variant="h6"
              color="inherit"
              sx={{ mr: { xs: 1, sm: 'auto' }, ml: { xs: 'auto', sm: 10, md: 18 } }}
            >
              {this.titleOrMarketName}
            </Typography>
            {imageUrl && (
              <ProfilePhoto publicId={convertImageUrlToPublicId(imageUrl)} />
            )}
            <Button
              color="inherit"
              onClick={() => this.logout()}
            >
              Logout
            </Button>
          </Toolbar>

          {this.collapsableDrawer}

        </AppBar>
      </Grid>
    );
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...marketActions,
}, dispatch);

const mapStateToProps = ({ markets, wranglers }) => ({
  markets: markets.markets,
  selectedMarket: markets.selectedMarket,
  currentWrangler: wranglers.currentWrangler,
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuAppBar);
